
import React, { useState, useEffect, useRef, useMemo, useId } from 'react';


const Sponsors = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [sponsorNames, setSponsorNames] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const textRef = useRef(null);

  
  useEffect(() => {
    const fetchSponsors = async () => {
      try {
        setLoading(true);
        setError(null);
        
        
        const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:3001';
        const apiUrl = `${baseUrl}/api/public/featured-sponsors`;
        
        console.log('Fetching sponsors from:', apiUrl);
        console.log('Current frontend URL:', window.location.href);
        console.log('Base URL:', baseUrl);
        
        const response = await fetch(apiUrl, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          
          mode: 'cors'
        });
        
        console.log('API Response Status:', response.status, response.statusText);
        console.log('API Response Headers:', Object.fromEntries(response.headers.entries()));
        
        
        const responseText = await response.text();
        console.log('Raw API Response:', responseText);
        
        if (!response.ok) {
          console.error('API response not OK:', response.status, response.statusText, responseText);
          setError(`API Error: ${response.status} ${response.statusText}`);
          setSponsorNames([]);
          return;
        }
        
        
        let data;
        try {
          data = JSON.parse(responseText);
          console.log('Parsed API Response Data:', data);
        } catch (parseError) {
          console.error('JSON Parse Error:', parseError);
          console.error('Response was:', responseText);
          setError(`JSON Parse Error: ${parseError.message}`);
          setSponsorNames([]);
          return;
        }
        
        if (data.success && Array.isArray(data.sponsors)) {
          console.log('Featured sponsors loaded:', data.sponsors);
          console.log('Number of sponsors:', data.sponsors.length);
          setSponsorNames(data.sponsors);
        } else if (Array.isArray(data.sponsors)) {
          
          console.log('Sponsors array found without success flag:', data.sponsors);
          setSponsorNames(data.sponsors);
        } else if (Array.isArray(data)) {
          
          console.log('Direct sponsors array:', data);
          setSponsorNames(data);
        } else {
          console.log('No sponsor data or invalid format:', data);
          setError('Invalid data format received from API');
          setSponsorNames([]);
        }
      } catch (error) {
        console.error('Error fetching sponsor data:', error);
        setError(`Network Error: ${error.message}`);
        setSponsorNames([]);
      } finally {
        setLoading(false);
      }
    };

    fetchSponsors();
  }, []);

  
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      {
        threshold: 0.3,
        rootMargin: '0px 0px -100px 0px'
      }
    );

    const currentRef = textRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  
  const animateText = (text) => {
    return text.split(' ').map((word, index) => (
      <span
        key={index}
        style={{
          display: 'inline-block',
          marginRight: '0.3em',
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
          transition: `all 0.6s cubic-bezier(0.4, 0, 0.2, 1) ${index * 0.1}s`
        }}
      >
        {word}
      </span>
    ));
  };


  
  const marqueeText = useMemo(() => {
    console.log('=== MARQUEE TEXT CALCULATION ===');
    console.log('useMemo called with:', { loading, error, sponsorNames });
    console.log('sponsorNames type:', typeof sponsorNames);
    console.log('sponsorNames isArray:', Array.isArray(sponsorNames));
    console.log('sponsorNames length:', sponsorNames?.length);
    console.log('sponsorNames content:', sponsorNames);
    
    if (loading) {
      console.log('-> Returning loading text');
      return "LOADING SPONSORS...";
    }
    
    if (error) {
      console.log('-> Error detected, showing fallback text:', error);
      return "THANK YOU TO OUR INVESTORS!";
    }
    
    if (sponsorNames && Array.isArray(sponsorNames) && sponsorNames.length > 0) {
      
      const validNames = sponsorNames.filter(name => {
        const isValid = name && typeof name === 'string' && name.trim();
        console.log(`Checking sponsor "${name}": valid = ${isValid}`);
        return isValid;
      });
      console.log('Valid sponsor names after filtering:', validNames);
      
      if (validNames.length > 0) {
        const result = validNames.join(" • ") + " •";
        console.log('-> Generated marquee text:', result);
        return result;
      } else {
        console.log('-> No valid sponsors after filtering');
      }
    } else {
      console.log('-> sponsorNames is empty, null, or not an array');
    }
    
    
    console.log('-> Using fallback text');
    return "THANK YOU TO OUR INVESTORS!";
  }, [loading, error, sponsorNames]);

  console.log('Final marquee text:', marqueeText);

  
  const isMobile = typeof window !== 'undefined' && window.innerWidth <= 900;

  return (
    <section id="sponsors-section"
      style={{ padding: '60px 20px 20px', color: '#fff', scrollMarginTop: '80px', position: 'relative', overflow: 'hidden' }}
    >
      {}
        <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
          
          {}
          {false && (
            <div style={{ textAlign: 'center', marginBottom: '0.3rem' }}>
              <h2 style={{
                fontSize: 'clamp(2rem, 4vw, 3rem)',
                fontWeight: '100',
                color: 'white',
                marginBottom: '0.1rem',
                letterSpacing: '0.05em'
              }}>
                OUR VALUED INVESTORS
              </h2>
              <p style={{
                fontSize: '1.2rem',
                color: '#9ca3af',
                maxWidth: '600px',
                margin: '0 auto',
                lineHeight: '1.6'
              }}>
                Partnering with industry leaders to shape the future of aerospace
              </p>
            </div>
          )}

          {

























































}

          {}
          {false && (
            <div style={{
              marginBottom: '0.1rem',
              minHeight: '150px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <CurvedLoopIntegrated 
                marqueeText={marqueeText}
                key={`${marqueeText}-${Date.now()}`} 
              />
            </div>
          )}

          {}
          <div style={{
            backgroundColor: 'transparent',
            border: 'none',
            borderRadius: '16px',
            overflow: 'hidden',
            marginBottom: '0.2rem'
          }}>
            
            <div
              style={{
                position: 'relative',
                zIndex: 2,
                padding: window.innerWidth <= 900 ? '0' : '4rem'
              }}
            >
              
              {}
              <div ref={textRef} style={{ marginBottom: '0.6rem', textAlign: 'center' }}>
                <h3 style={{
                  fontSize: 'clamp(1.5rem, 2.5vw, 2rem)',
                  fontWeight: '100',
                  color: 'white',
                  marginBottom: '2rem',
                  letterSpacing: '0.03em',
                  textAlign: 'center'
                }}>
                  {isMobile ? "Growing Aluren Through Strategic Partnerships" : animateText("Growing Aluren Through Strategic Partnerships")}
                </h3>
                <div style={{
                  fontSize: '1.1rem',
                  color: '#cbd5e1',
                  lineHeight: '1.8',
                  marginBottom: '0.4rem',
                  textAlign: 'center'
                }}>
                  <p style={{ marginBottom: '0.3rem' }}>
                    {isMobile ? "Our success is built on the foundation of exceptional partnerships with forward-thinking organizations and investors who share our vision for Aluren." : animateText("Our success is built on the foundation of exceptional partnerships with forward-thinking organizations and investors who share our vision for Aluren.")}
                  </p>
                  <p style={{ marginBottom: '0.3rem' }}>
                    {isMobile ? "The support from investors and the procuration of a team that shares our drive for advancing aerospace and bettering life on earth enables us to push the boundaries of aerospace innovation, driving advancements that shape the future of spaceflight and orbital logistics." : animateText("The support from investors and the procuration of a team that shares our drive for advancing aerospace and bettering life on earth enables us to push the boundaries of aerospace innovation, driving advancements that shape the future of spaceflight and orbital logistics.")}
                  </p>
                  <p>
                    {isMobile ? "Join us in shaping the future of space technology and be a part of the many exciting opportunities in the rapidly expanding launch market. From satellite deployment to space-based compute to human spaceflight, Aluren aims to be at the forefront of a new era in space utilization." : animateText("Join us in shaping the future of space technology and be a part of the many exciting opportunities in the rapidly expanding launch market. From satellite deployment to space-based compute to human spaceflight, Aluren aims to be at the forefront of a new era in space utilization.")}
                  </p>
                  <br />
                  <br />
                  <br />
                  <br />
                  <p>
                    {("Thank you for your eyes and time as we push headstrong into the future of Aluren.")}
                  </p>
                  <p style={{ textAlign: 'right', paddingRight: '2rem' }}>
                    {("~ John Ai, Founder of Aluren Dynamics")}
                  </p>
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1.5rem', marginTop: '0.5rem', flexWrap: 'wrap' }}>
                    <img
                      src={`${process.env.PUBLIC_URL}/John Sig.png`}
                      alt="John signature"
                      style={{
                        maxWidth: '240px',
                        width: '100%',
                        height: 'auto',
                        filter: 'invert(1)'
                      }}
                    />
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        {}
        <div style={{
          position: 'absolute',
          left: 0,
          right: 0,
          bottom: 0,
          height: '10%',
          background: 'linear-gradient(to bottom, rgba(0,0,0,0), rgba(0,0,0,1))',
          pointerEvents: 'none'
        }} />
    </section>
  );
};


const CurvedLoopIntegrated = ({
  marqueeText = "THANK YOU!",
  speed = 1.4,
  curveAmount = 0,
  direction = "left",
  interactive = true,
}) => {
  const text = useMemo(() => {
    console.log('CurvedLoopIntegrated received marqueeText:', marqueeText);
    const hasTrailing = /\s|\u00A0$/.test(marqueeText);
    const processedText = (hasTrailing ? marqueeText.replace(/\s+$/, "") : marqueeText) + "\u00A0";
    console.log('CurvedLoopIntegrated processed text:', processedText);
    return processedText;
  }, [marqueeText]);

  const measureRef = useRef(null);
  const textPathRef = useRef(null);
  const pathRef = useRef(null);
  const [spacing, setSpacing] = useState(0);
  const [offset, setOffset] = useState(0);
  const uid = useId();
  const pathId = `curve-${uid}`;
  const pathD = `M-100,40 Q500,${40 + curveAmount} 1540,40`;

  const dragRef = useRef(false);
  const lastXRef = useRef(0);
  const dirRef = useRef(direction);
  const velRef = useRef(0);

  const textLength = spacing;
  const totalText = textLength ? Array(Math.ceil(1800 / textLength) + 2).fill(text).join('') : text;
  const ready = spacing > 0;

  useEffect(() => {
    if (measureRef.current) {
      const newSpacing = measureRef.current.getComputedTextLength();
      console.log('Setting spacing:', newSpacing);
      setSpacing(newSpacing);
    }
  }, [text]);

  useEffect(() => {
    if (!spacing) return;
    if (textPathRef.current) {
      const initial = -spacing;
      textPathRef.current.setAttribute("startOffset", initial + "px");
      setOffset(initial);
    }
  }, [spacing]);

  useEffect(() => {
    if (!spacing || !ready) return;
    let frame = 0;
    const step = () => {
      if (!dragRef.current && textPathRef.current) {
        const delta = dirRef.current === "right" ? speed : -speed;
        const currentOffset = parseFloat(textPathRef.current.getAttribute("startOffset") || "0");
        let newOffset = currentOffset + delta;

        const wrapPoint = spacing;
        if (newOffset <= -wrapPoint) newOffset += wrapPoint;
        if (newOffset > 0) newOffset -= wrapPoint;

        textPathRef.current.setAttribute("startOffset", newOffset + "px");
        setOffset(newOffset);
      }
      frame = requestAnimationFrame(step);
    };
    frame = requestAnimationFrame(step);
    return () => cancelAnimationFrame(frame);
  }, [spacing, speed, ready]);

  const onPointerDown = (e) => {
    if (!interactive) return;
    dragRef.current = true;
    lastXRef.current = e.clientX;
    velRef.current = 0;
    e.target.setPointerCapture(e.pointerId);
  };

  const onPointerMove = (e) => {
    if (!interactive || !dragRef.current || !textPathRef.current) return;
    const dx = e.clientX - lastXRef.current;
    lastXRef.current = e.clientX;
    velRef.current = dx;

    const currentOffset = parseFloat(textPathRef.current.getAttribute("startOffset") || "0");
    let newOffset = currentOffset + dx;

    const wrapPoint = spacing;
    if (newOffset <= -wrapPoint) newOffset += wrapPoint;
    if (newOffset > 0) newOffset -= wrapPoint;

    textPathRef.current.setAttribute("startOffset", newOffset + "px");
    setOffset(newOffset);
  };

  const endDrag = () => {
    if (!interactive) return;
    dragRef.current = false;
    dirRef.current = velRef.current > 0 ? "right" : "left";
  };

  const cursorStyle = interactive
    ? dragRef.current
      ? "grabbing"
      : "grab"
    : "auto";

  console.log('CurvedLoopIntegrated rendering with text:', text, 'ready:', ready);

  return (
    <div
      style={{ 
        width: '100%',
        height: '120px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        visibility: ready ? "visible" : "hidden", 
        cursor: cursorStyle 
      }}
      onPointerDown={onPointerDown}
      onPointerMove={onPointerMove}
      onPointerUp={endDrag}
      onPointerLeave={endDrag}
    >
      <svg style={{
        userSelect: 'none',
        width: '100%',
        aspectRatio: '100 / 12',
        overflow: 'visible',
        display: 'block',
        fontSize: 'clamp(2rem, 4vw, 3.5rem)',
        fill: '#ffffff',
        fontWeight: '200',
        textTransform: 'uppercase',
        lineHeight: '1',
        letterSpacing: '0.1em'
      }} viewBox="0 0 1440 120">
        <text
          ref={measureRef}
          xmlSpace="preserve"
          style={{ visibility: "hidden", opacity: 0, pointerEvents: "none" }}
        >
          {text}
        </text>
        <defs>
          <path
            ref={pathRef}
            id={pathId}
            d={pathD}
            fill="none"
            stroke="transparent"
          />
        </defs>
        {ready && (
          <text fontWeight="200" xmlSpace="preserve">
            <textPath ref={textPathRef} href={`#${pathId}`} startOffset={offset + "px"} xmlSpace="preserve">
              {totalText}
            </textPath>
          </text>
        )}
      </svg>
    </div>
  );
};

export default Sponsors;